/* tslint:disable */
import * as Types from '../../../../../../graphql-api/gql-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ExportSearchQueryVariables = Types.Exact<{
  query: Types.SearchQuery;
}>;


export type ExportSearchQuery = { exportSearch: boolean };

export const ExportSearchDocument = gql`
    query ExportSearch($query: SearchQuery!) {
  exportSearch(query: $query)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportSearchGQL extends Apollo.Query<ExportSearchQuery, ExportSearchQueryVariables> {
    document = ExportSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }